webpackJsonp([69],{

/***/ 1352:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1357), __esModule: true };

/***/ }),

/***/ 1357:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(234);
__webpack_require__(143);
module.exports = __webpack_require__(1358);


/***/ }),

/***/ 1358:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(41);
var get = __webpack_require__(145);
module.exports = __webpack_require__(12).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 1376:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(1381);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(1352);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 1381:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1382), __esModule: true };

/***/ }),

/***/ 1382:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(234);
__webpack_require__(143);
module.exports = __webpack_require__(1383);


/***/ }),

/***/ 1383:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(146);
var ITERATOR = __webpack_require__(22)('iterator');
var Iterators = __webpack_require__(66);
module.exports = __webpack_require__(12).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ 1508:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = regType;
/**
 * 正则验证方法库
 */
function regType(type) {
  var exp = void 0;

  switch (type) {
    default:
      exp = new RegExp();
      break;
    case 'number':
      // 纯数字
      exp = /^\d+$/gi;
      break;
    case 'email':
      // 邮箱
      exp = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]+$/gi;
      break;
    case 'httpUrl':
      // HTTP/HTTPS URL
      exp = /^(http|https):\/\/([0-9a-z_!~*'()-]+\.)*(([0-9a-z][0-9a-z-]{0,61})?[0-9a-z]\.)([a-z]{2,6})((\/?)|(\/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+(\/?))$/gi;
      break;
    case 'telephone':
      // 手机
      exp = /^1[3456789]\d{9}$/gi;
      break;
    case 'phone':
      // 座机
      exp = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/gi;
      break;
    case 'imgData':
      // data-url图片
      exp = /^data:image\//gi;
      break;
    case 'money':
      // 金额
      exp = /^(\d+)((\.){1,1}(\d){1,2})?$/g;
      break;
  }

  return exp;
}

/***/ }),

/***/ 2649:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FairPrizeEdit_js__ = __webpack_require__(3877);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FairPrizeEdit_js__["a"]; });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/***/ }),

/***/ 289:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FairPrizeEdit_vue__ = __webpack_require__(2649);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_936ee6c8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FairPrizeEdit_vue__ = __webpack_require__(3878);
function injectStyle (ssrContext) {
  __webpack_require__(3875)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-936ee6c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FairPrizeEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_936ee6c8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FairPrizeEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3875:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3876);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("c4b037ba", content, true, {});

/***/ }),

/***/ 3876:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".add-coupon-btn[data-v-936ee6c8]{width:100%;padding:10px 5px;-webkit-box-sizing:border-box;box-sizing:border-box;border-bottom:1px dashed #ddd}.add-coupon-btn button[data-v-936ee6c8]{margin:0}.form-panel[data-v-936ee6c8]{margin:30px 0 20px}table.form-table[data-v-936ee6c8]{width:100%;border-collapse:collapse}table.form-table td[data-v-936ee6c8],table.form-table th[data-v-936ee6c8]{padding:10px 5px;border-bottom:1px solid #ddd}table.form-table th[data-v-936ee6c8]{color:#999}", "", {"version":3,"sources":["/workspace/src/views/fair-prize/pages/FairPrizeEdit.vue"],"names":[],"mappings":"AACA,iCAAiC,WAAW,iBAAiB,8BAA8B,sBAAsB,6BAA6B,CAC7I,AACD,wCAAwC,QAAQ,CAC/C,AACD,6BAA6B,kBAAkB,CAC9C,AACD,kCAAkC,WAAW,wBAAwB,CACpE,AACD,0EAA0E,iBAAiB,4BAA4B,CACtH,AACD,qCAAqC,UAAU,CAC9C","file":"FairPrizeEdit.vue","sourcesContent":["\n.add-coupon-btn[data-v-936ee6c8]{width:100%;padding:10px 5px;-webkit-box-sizing:border-box;box-sizing:border-box;border-bottom:1px dashed #DDD\n}\n.add-coupon-btn button[data-v-936ee6c8]{margin:0\n}\n.form-panel[data-v-936ee6c8]{margin:30px 0 20px\n}\ntable.form-table[data-v-936ee6c8]{width:100%;border-collapse:collapse\n}\ntable.form-table th[data-v-936ee6c8],table.form-table td[data-v-936ee6c8]{padding:10px 5px;border-bottom:1px solid #DDD\n}\ntable.form-table th[data-v-936ee6c8]{color:#999\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3877:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_regExp__ = __webpack_require__(1508);







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      inputWith: 12,

      prizeFormRules: {
        name: [{ required: true, message: '奖品名称不能为空', trigger: 'blur' }],
        description: [{ required: true, message: '奖品描述不能为空', trigger: 'blur' }],
        type: [{ required: true, message: '奖品类型不能为空', trigger: 'blur' }],
        img: [{ required: true, message: '奖品图片不能为空', trigger: 'blur' }],
        package_time_limit: [{ required: true, message: '券包的有效期不能为空', trigger: 'blur' }, { validator: this.positiveIntegerValidator, trigger: 'blur' }],
        coupon_time_limit: [{ required: true, message: '券的有效期不能为空', trigger: 'blur' }, { validator: this.positiveIntegerValidator, trigger: 'blur' }],
        coupon_amount: [{ required: true, message: '券总数不能为空', trigger: 'blur' }, { validator: this.positiveIntegerValidator, trigger: 'blur' }],
        surprise_coupon_after: [{ required: true, message: '惊喜券位置不能为空', trigger: 'blur' }, { validator: this.positiveIntegerValidator, trigger: 'blur' }]
      },

      form: {
        name: '',
        description: '',
        type: null,
        img: '',
        package_time_limit: '',
        coupon_time_limit: '',
        coupon_amount: '',
        surprise_coupon_after: '',
        coupons: []
      },

      options: {
        fairPrizeType: [],
        fairPrizeCouponType: []
      }
    };
  },


  computed: {},

  created: function created() {
    var _this = this;

    if (this.$route.params.prizeId) {
      // 修改奖品
      request.all.page([request('getFairPrizeOptions'), request('getFairPrizeDetail', this.$route.params.prizeId)]).then(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            optionData = _ref2[0].data,
            prizeData = _ref2[1].data;

        _this.setFairPrizeOptions(optionData);
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(_this.form, prizeData);
      });
    } else {
      // 添加奖品
      request.common('getFairPrizeOptions').then(function (_ref3) {
        var data = _ref3.data;

        _this.setFairPrizeOptions(data);
      });
    }
  },


  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapActions"])([]), {
    setFairPrizeOptions: function setFairPrizeOptions(data) {
      this.options.fairPrizeType = data.fairPrizeType;
      this.options.fairPrizeCouponType = data.fairPrizeCouponType;
    },
    onChangePrizeImg: function onChangePrizeImg(file, fileList) {
      var isImg = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png';
      var isLt2M = file.raw.size / 1024 / 1024 < 2;
      if (!isImg) {
        this.$message.error('请上传jpg/jpeg/png图片!');
        this.$refs.upload.clearFiles();
        return false;
      }
      if (!isLt2M) {
        this.$message.error('大小不能超过2MB!');
        this.$refs.upload.clearFiles();
        return false;
      }
      this.onUploadPrizeImg(file.raw);
    },
    onUploadPrizeImg: function onUploadPrizeImg(file) {
      var _this2 = this;

      var formData = new FormData();
      formData.append('file', file);
      return request.common('uploadFair', formData).then(function (_ref4) {
        var data = _ref4.data;

        _this2.form.img = data;
        _this2.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
      });
    },
    onRemovePrizeImg: function onRemovePrizeImg(file, fileList) {
      this.form.img = '';
    },


    // 添加券
    addCoupon: function addCoupon() {
      var couponData = {
        type: null,
        amount: '',
        order_price_limit: '',
        num: '',
        status: 1,
        desc: ''
      };

      this.form.coupons.push(couponData);
    },


    // 删除券
    deleteCoupon: function deleteCoupon(couponIndex) {
      this.form.coupons.splice(couponIndex, 1);
    },


    // 修改奖品类型
    onChangePrizeType: function onChangePrizeType() {
      this.form.package_time_limit = '';
      this.form.coupon_time_limit = '';
      this.form.coupon_amount = '';
      this.form.surprise_coupon_after = '';
      this.form.coupons = [];
    },


    // 验证正整数输入
    positiveIntegerValidator: function positiveIntegerValidator(rule, value, callback) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_5__utils_regExp__["a" /* regType */])('number').test(String(value))) {
        callback(new Error('请输入正整数'));
      } else {
        callback();
      }
    },
    onSubmit: function onSubmit() {
      var _this3 = this;

      this.$refs.form.validate(function (valid) {
        if (valid) {
          var submitModel = null;

          switch (_this3.form.type) {
            default:
              submitModel = _this3.submitDefault();
              break;
            case 40:
              submitModel = _this3.submitCoupon();
              break;
          }

          if (!submitModel) return;

          request.common(_this3.$route.params.prizeId ? 'editFairPrize' : 'createFairPrize', _this3.$route.params.prizeId ? {
            id: _this3.$route.params.prizeId,
            data: submitModel
          } : submitModel).then(function (res) {
            _this3.$router.push({ name: '活动奖品管理' });
          });
        }
      });
    },
    submitDefault: function submitDefault() {
      var submitModel = {};
      var defaultKeys = ['name', 'description', 'type', 'img'];

      for (var k in this.form) {
        if (defaultKeys.indexOf(k) >= 0) {
          submitModel[k] = this.form[k];
        }
      }

      return submitModel;
    },
    submitCoupon: function submitCoupon() {
      if (this.form.coupons.length < 1) {
        this.$message.error('请至少添加一张券');
        return false;
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.form.coupons), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var couponItem = _step.value;

          if (!couponItem.type) {
            this.$message.error('请选择券类型');
            return false;
          } else if (!couponItem.amount || !Object(__WEBPACK_IMPORTED_MODULE_5__utils_regExp__["a" /* regType */])('money').test(couponItem.amount)) {
            this.$message.error('请输入合适的添加券金额');
            return false;
          } else if (!couponItem.amount || !Object(__WEBPACK_IMPORTED_MODULE_5__utils_regExp__["a" /* regType */])('money').test(couponItem.amount)) {
            this.$message.error('请输入合适的添加券消耗条件');
            return false;
          } else if (!couponItem.num || !Object(__WEBPACK_IMPORTED_MODULE_5__utils_regExp__["a" /* regType */])('number').test(couponItem.num)) {
            this.$message.error('请输入合适的添加券数量');
            return false;
          }
        }

        // 检查有效券的总数量
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var totalCouponNum = 0;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.form.coupons), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _couponItem = _step2.value;

          if (_couponItem.status === 1) {
            totalCouponNum += Number(_couponItem.num);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      if (totalCouponNum !== Number(this.form.coupon_amount)) {
        this.$message.error('券总数必须等于所有有效券的数量之和');
        return false;
      }

      return this.form;
    }
  })
});

/***/ }),

/***/ 3878:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('h3',[_vm._v(_vm._s(_vm.$route.meta.title))]),_vm._v(" "),_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("活动管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"show-header":false}},[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.prizeFormRules,"label-width":"140px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('el-form-item',{attrs:{"prop":"name","label":"奖品名称:"}},[_c('el-col',{attrs:{"span":_vm.inputWith}},[_c('el-input',{attrs:{"placeholder":"建议奖品名称不超过13个字","size":"small","clearable":""},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"description","label":"奖品描述:"}},[_c('el-col',{attrs:{"span":_vm.inputWith}},[_c('el-input',{attrs:{"placeholder":"请输入奖品描述","size":"small","clearable":""},model:{value:(_vm.form.description),callback:function ($$v) {_vm.$set(_vm.form, "description", $$v)},expression:"form.description"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"type","label":"奖品类型:"}},[_c('el-col',{attrs:{"span":_vm.inputWith}},[_c('el-select',{attrs:{"size":"small","disabled":!!_vm.$route.params.prizeId,"clearable":""},on:{"change":_vm.onChangePrizeType},model:{value:(_vm.form.type),callback:function ($$v) {_vm.$set(_vm.form, "type", $$v)},expression:"form.type"}},_vm._l((_vm.options.fairPrizeType),function(prizeTypeItem){return _c('el-option',{key:prizeTypeItem.value,attrs:{"label":prizeTypeItem.label,"value":prizeTypeItem.value}})}),1)],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"img","label":"上传图片:"}},[_c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":"","auto-upload":false,"show-file-list":false,"on-change":_vm.onChangePrizeImg,"on-remove":_vm.onRemovePrizeImg,"size":"small"}},[(_vm.form.img)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.form.img}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})])],1),_vm._v(" "),(_vm.form.type === 40)?_c('el-row',[_c('el-form-item',{attrs:{"prop":"package_time_limit","label":"券包的有效期(天):"}},[_c('el-col',{attrs:{"span":_vm.inputWith}},[_c('el-input',{attrs:{"placeholder":"请输入券包的有效期","size":"small","clearable":""},model:{value:(_vm.form.package_time_limit),callback:function ($$v) {_vm.$set(_vm.form, "package_time_limit", $$v)},expression:"form.package_time_limit"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"coupon_time_limit","label":"券的有效期(天):"}},[_c('el-col',{attrs:{"span":_vm.inputWith}},[_c('el-input',{attrs:{"placeholder":"请输入券的有效期","size":"small","clearable":""},model:{value:(_vm.form.coupon_time_limit),callback:function ($$v) {_vm.$set(_vm.form, "coupon_time_limit", $$v)},expression:"form.coupon_time_limit"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"coupon_amount","label":"券总数:"}},[_c('el-col',{attrs:{"span":_vm.inputWith}},[_c('el-input',{attrs:{"placeholder":"请输入券总数","size":"small","clearable":""},model:{value:(_vm.form.coupon_amount),callback:function ($$v) {_vm.$set(_vm.form, "coupon_amount", $$v)},expression:"form.coupon_amount"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"surprise_coupon_after","label":"惊喜券位置:"}},[_c('el-col',{attrs:{"span":12}},[_c('el-input',{attrs:{"size":"small","clearable":""},model:{value:(_vm.form.surprise_coupon_after),callback:function ($$v) {_vm.$set(_vm.form, "surprise_coupon_after", $$v)},expression:"form.surprise_coupon_after"}},[_c('template',{slot:"prepend"},[_vm._v("第")]),_vm._v(" "),_c('template',{slot:"append"},[_vm._v("张以后")])],2)],1)],1),_vm._v(" "),_c('div',{staticClass:"add-coupon-btn"},[_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.addCoupon()}}},[_vm._v("添加券\n          ")])],1),_vm._v(" "),(_vm.form.coupons.length > 0)?_c('table',{staticClass:"form-table"},[_c('thead',[_c('tr',[_c('th',[_vm._v("券")]),_vm._v(" "),_c('th',[_vm._v("金额")]),_vm._v(" "),_c('th',[_vm._v("备注")]),_vm._v(" "),_c('th',[_vm._v("消耗条件(元)")]),_vm._v(" "),_c('th',[_vm._v("数量")]),_vm._v(" "),_c('th',[_vm._v("有效")]),_vm._v(" "),_c('th',[_vm._v("操作")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.form.coupons),function(couponItem,couponIndex){return _c('tr',[_c('td',[_c('el-select',{attrs:{"size":"mini"},model:{value:(couponItem.type),callback:function ($$v) {_vm.$set(couponItem, "type", $$v)},expression:"couponItem.type"}},_vm._l((_vm.options.fairPrizeCouponType),function(couponTypeItem){return _c('el-option',{key:couponTypeItem.value,attrs:{"label":couponTypeItem.label,"value":couponTypeItem.value}})}),1)],1),_vm._v(" "),_c('td',[_c('el-input',{attrs:{"size":"mini","clearable":""},model:{value:(couponItem.amount),callback:function ($$v) {_vm.$set(couponItem, "amount", $$v)},expression:"couponItem.amount"}})],1),_vm._v(" "),_c('td',[_c('el-input',{attrs:{"size":"mini","clearable":""},model:{value:(couponItem.desc),callback:function ($$v) {_vm.$set(couponItem, "desc", $$v)},expression:"couponItem.desc"}})],1),_vm._v(" "),_c('td',[_c('el-input',{attrs:{"size":"mini","clearable":""},model:{value:(couponItem.order_price_limit),callback:function ($$v) {_vm.$set(couponItem, "order_price_limit", $$v)},expression:"couponItem.order_price_limit"}})],1),_vm._v(" "),_c('td',[_c('el-input',{attrs:{"size":"mini","clearable":""},model:{value:(couponItem.num),callback:function ($$v) {_vm.$set(couponItem, "num", $$v)},expression:"couponItem.num"}})],1),_vm._v(" "),_c('td',[_c('el-switch',{attrs:{"active-value":1,"inactive-value":0},model:{value:(couponItem.status),callback:function ($$v) {_vm.$set(couponItem, "status", $$v)},expression:"couponItem.status"}})],1),_vm._v(" "),_c('td',[_c('el-button',{attrs:{"type":"danger","size":"mini","disabled":'id' in couponItem},on:{"click":function($event){return _vm.deleteCoupon(couponIndex)}}},[_vm._v("\n                删除\n              ")])],1)])}),0)]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('el-row',{staticClass:"form-panel"},[_c('el-button',{attrs:{"type":"primary","size":"mini","native-type":"submit"}},[_vm._v("提交\n        ")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){return _vm.$router.push({name: '活动奖品管理'})}}},[_vm._v("取消\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/69.3db8bc8e3f7f204bd838.js